import { SET_NEW_INVENTORY, SET_INVENTORY, REMOVE_ITEM_INVENTORY, EDIT_ITEM_INVENTORY } from '../../actions/inventory'

export const inventory = (state = {}, action) => {
    switch(action.type) {
        case SET_NEW_INVENTORY: {
            return { ...state, [action.payload.id]: action.payload };
        }
        case SET_INVENTORY: {
            return action.payload;
        }
        case REMOVE_ITEM_INVENTORY:
            const newState = state
            delete newState[action.payload.id]
            return { ...newState };
        case EDIT_ITEM_INVENTORY:
            return { ...state, [action.payload.id]: action.payload };
        default:
            return state;
    }
}
